import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=4efa8712"
import script from "./Rooms.vue?vue&type=script&lang=js"
export * from "./Rooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/common/Button.vue').default,Currency: require('/vercel/path0/components/partials/Currency.vue').default,CancellationButton: require('/vercel/path0/components/partials/CancellationButton.vue').default,RoomGallery: require('/vercel/path0/components/partials/RoomGallery.vue').default,Info: require('/vercel/path0/components/common/Info.vue').default,ModalScreen: require('/vercel/path0/components/common/ModalScreen.vue').default})
